import React, { Component } from "react";
import Chart from "react-apexcharts";

class barsChart extends Component {
  constructor(props) {
    super(props);
    this.state = {
          
          // colors: ["#f88477","#9e63f0"],
          series: [{
            name:'Received',
            data: [ 13, 10, 22, 28, 21,  21,  30, 16,  13, 21, 30,13]
          },{
            name:'Payout',
            data: [21, 22, 10,  16,28, 21, 13, 30, 21, 16, 13,30]
          }],
      options: {
        colors: ["#1d75ee","#9e63f0"],
        chart: {
          type: 'bar',
          height: 350,
        },
        tooltip: {
          enabled: true,
          x: {
            show: true,
            formatter: undefined,
        },
          y: {
            show: true,
            formatter: function(value){
              return '$' + Number(value).toLocaleString('en-IN');
            },
        }
        },
        plotOptions: {
          bar: {
            borderRadius: 4,
            horizontal: true,
          }
        },
        dataLabels: {
          enabled: true,
          formatter: function (value) {
            return '$' + Number(value).toLocaleString('en-IN');
          }
        },
        xaxis: {
          categories: this.props.labels??[],
          
          labels: {
            formatter: function (value) {
              return '$' + Number(value).toLocaleString('en-IN');
            },
            style: {
              fontSize: '12px',
              fontWeight: 800,

            }
          }
          },
        
        yaxis: {
          labels: {
            style: {
              fontSize: '12px',
              fontWeight: 800,
              color:'red'
            }
          },
        
        },
        
        grid: {
          show: true,
          strokeDashArray: 7,
          xaxis: {
            lines: { 
              show: false  //or just here to disable only y axis
             },
            labels: {
              formatter: function (value) {
                return '$' + Number(value).toLocaleString('en-IN');
              }
            }
           },
          yaxis: {
            lines: { 
              show: true,  //or just here to disable only y axis
             }
             
           },
        },
      },
    
    
    };
    
    }

    componentDidUpdate(prevProps) {
      if (prevProps.series !== this.props.series) {

        this.setState({
          options: {
            ...this.state.options,
            xaxis: {
              ...this.state.options.xaxis,
              categories:  this.props.labels,
              labels: {
                style: {
                  fontSize: '10px',
                  fontWeight: 500,
                  color:'red'
                }
              }
            }
          }
          
        });

      //  console.log(this.state);
      }
    }
  render() {
    return (
      <>
      
              <Chart
                options={this.state.options}
                series={this.props.series}
                type="bar"
                height="800"

                />
      </>
    );
  }
}
 
export default barsChart;